import Resource from './Resource';

class SimilarCustomers extends Resource {
	constructor() {
		super('similarCustomers');
	}
}

export default new SimilarCustomers();
